 import React, { forwardRef } from 'react';

 
 import './EasySection.css';
 

const EasySection = forwardRef((props, ref) => {

return (


<section ref={ref} className="easySection">

<div dir="ltr"  style={{
    textAlign:"center",
    
    //  maxWidth: "550px" ,
    //   backgroundColor:"pink"
      }}>
 
<h4 className='color-white  second-easy ' style={{ textAlign:"center"}} dir="ltr"> 
 עבודה מדויקת, מחושבת ועמוקה שנבנית כדי להחזיק לאורך זמן, לא רק לרגע
  </h4>

 
</div>


 

 




</section >
  );
});

export default EasySection;